import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Topbar from './Topbar';
import Navbar from './Navbar';

const Header = () => {
  return (
    <>
      {/* <Topbar /> */}
      <Navbar />
    </>
  );
};

export default Header; 